"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentOrderTag = void 0;
var FulfillmentOrderTag;
(function (FulfillmentOrderTag) {
    FulfillmentOrderTag["AIRSHOP_ORDER"] = "AIRSHOP_ORDER";
    FulfillmentOrderTag["AMAZON_SFP"] = "AMAZON_SFP";
    FulfillmentOrderTag["BACKORDER"] = "BACKORDER";
    FulfillmentOrderTag["BRANDED_ORDER"] = "BRANDED_ORDER";
    FulfillmentOrderTag["BULK_ORDER"] = "BULK_ORDER";
    FulfillmentOrderTag["BUNDLED_PRODUCTS"] = "BUNDLED_PRODUCTS";
    FulfillmentOrderTag["DDP"] = "DDP";
    FulfillmentOrderTag["DELIVERED_DUTY_PAID"] = "DELIVERED_DUTY_PAID";
    FulfillmentOrderTag["DISTRIBUTION_ORDER"] = "DISTRIBUTION_ORDER";
    FulfillmentOrderTag["DROPSHIP_ORDER"] = "DROPSHIP_ORDER";
    FulfillmentOrderTag["EBAY_ESTIMATED_FAST_TAG"] = "EBAY_ESTIMATED_FAST_TAG";
    FulfillmentOrderTag["EBAY_FAST_TAG"] = "EBAY_FAST_TAG";
    FulfillmentOrderTag["EXCLUDE_FROM_OCC"] = "EXCLUDE_FROM_OCC";
    FulfillmentOrderTag["FAST_SHIPPING"] = "FAST_SHIPPING";
    FulfillmentOrderTag["FEFO_ORDER"] = "FEFO_ORDER";
    FulfillmentOrderTag["GOOGLE_FAST_TAG"] = "GOOGLE_FAST_TAG";
    FulfillmentOrderTag["INTERNATIONAL_ORDER"] = "INTERNATIONAL_ORDER";
    FulfillmentOrderTag["INVENTORY_DISPOSAL"] = "INVENTORY_DISPOSAL";
    FulfillmentOrderTag["INVENTORY_REMOVAL"] = "INVENTORY_REMOVAL";
    FulfillmentOrderTag["INVENTORY_TRACKING"] = "INVENTORY_TRACKING";
    FulfillmentOrderTag["INVENTORY_TRANSFER"] = "INVENTORY_TRANSFER";
    FulfillmentOrderTag["LOT_DISPOSAL"] = "LOT_DISPOSAL";
    FulfillmentOrderTag["LOT_REMOVAL"] = "LOT_REMOVAL";
    FulfillmentOrderTag["PACKING_SLIP_INCLUDED"] = "PACKING_SLIP_INCLUDED";
    FulfillmentOrderTag["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
    FulfillmentOrderTag["RATE_SHOPPING_SCHEME_BASED_ON_SLA"] = "RATE_SHOPPING_SCHEME_BASED_ON_SLA";
    FulfillmentOrderTag["REPLACE_LOST_ORDER"] = "REPLACE_LOST_ORDER";
    FulfillmentOrderTag["REQUIRES_PRINTED_COMMERCIAL_INVOICE"] = "REQUIRES_PRINTED_COMMERCIAL_INVOICE";
    FulfillmentOrderTag["SHIP_TO_STORE_CARTON_ORDER"] = "SHIP_TO_STORE_CARTON_ORDER";
    FulfillmentOrderTag["SHIP_TO_STORE_ORDER"] = "SHIP_TO_STORE_ORDER";
    FulfillmentOrderTag["SHOPIFY_FAST_TAG"] = "SHOPIFY_FAST_TAG";
    FulfillmentOrderTag["SHOPIFY_PROMISE"] = "SHOPIFY_PROMISE";
    FulfillmentOrderTag["SIGNATURE_REQUIRED_ACCOUNT"] = "SIGNATURE_REQUIRED_ACCOUNT";
    FulfillmentOrderTag["SIGNATURE_REQUIRED_PRODUCT"] = "SIGNATURE_REQUIRED_PRODUCT";
    FulfillmentOrderTag["STRESS_TEST"] = "STRESS_TEST";
    FulfillmentOrderTag["SUBSCRIPTION_ORDER"] = "SUBSCRIPTION_ORDER";
    FulfillmentOrderTag["TEST_ORDER"] = "TEST_ORDER";
    FulfillmentOrderTag["TRIBAL_NUTRITION_REPLACEMENT"] = "TRIBAL_NUTRITION_REPLACEMENT";
    FulfillmentOrderTag["UNBRANDED_PROMISE"] = "UNBRANDED_PROMISE";
    FulfillmentOrderTag["USE_CONTAINER_FIT_V4"] = "USE_CONTAINER_FIT_V4";
    FulfillmentOrderTag["USE_ONLY_RETAILER_CARRIER_ACCOUNTS"] = "USE_ONLY_RETAILER_CARRIER_ACCOUNTS";
    FulfillmentOrderTag["USE_ONLY_SELLER_CARRIER_ACCOUNTS"] = "USE_ONLY_SELLER_CARRIER_ACCOUNTS";
    FulfillmentOrderTag["USE_ONLY_SPECIFIED_SHIP_METHOD"] = "USE_ONLY_SPECIFIED_SHIP_METHOD";
    FulfillmentOrderTag["USE_ONLY_SPECIFIED_WAREHOUSE"] = "USE_ONLY_SPECIFIED_WAREHOUSE";
    FulfillmentOrderTag["WALMART_FAST_TAG"] = "WALMART_FAST_TAG";
    FulfillmentOrderTag["WEBSITE_FAST_TAG"] = "WEBSITE_FAST_TAG";
    FulfillmentOrderTag["WISH_EXPRESS_FAST_TAG"] = "WISH_EXPRESS_FAST_TAG";
    FulfillmentOrderTag["ZBP_ENABLED"] = "ZBP_ENABLED";
})(FulfillmentOrderTag = exports.FulfillmentOrderTag || (exports.FulfillmentOrderTag = {}));
//# sourceMappingURL=FulfillmentOrderTag.js.map